import React, { useState } from 'react';
import { StyledAccordionWrapper } from './StyledAccordionWrapper';
import {AccordionSingle} from '../../components';

const AccordionWrapper = ({children}) => {
  
  const [currentAcc, setCurrentAcc] = useState(-1)

  const arrayAccordion = [
    {
      isDouble: false,
      title: "What is the difference between AR, VR, Mixed Reality, and Full Reality?",
      content: [
        {
          innerTitle: "Virtual Reality (VR)",
          innertText: "Virtual Reality is a computer-simulated reality that totally replaces the real world, a fully artificial digital environment where the user is immersed thanks to the use of digital devices. The environment can be a virtual replica of a real-world place or a completely imaginary world. The user can have more or less freedom of movement and be a simple spectator or carry out more or less complex interactions with the environment and objects."
        },
        {
          innerTitle: "Augmented Reality (AR)",
          innertText: "Augmented Reality is a reality where digital contents are overlaid on top of the real-world environment. It does not replace but enhances reality by adding further information to it."
        },
        {
          innerTitle: "Mixed Reality (MR)",
          innertText: "Mixed Reality is a blend of the real and virtual worlds where physical and digital contents co-exist and interact in real-time."
        }
      ]
    },
    {
      isDouble: false,
      title: "What are the applications of a 3D Digital Twin?",
      content: [
        {
          innertText: `
          A Digital Twin is the digital replica of a physical object or space. 3D Digital Twins are  three-dimensional models that mirror their physical counterparts in appearance and dimensions.
          They can be used across different platforms as well as sectors and activities, ranging from manufacturing, to engineering, healthcare, retail, marketing and advertising, entertainment, design, construction and real estate, automotive, fashion, education, etc.
          `
        }
      ]
    },
    {
      isDouble: true,
      title: "What is the difference between 3DoF and 6DoF?",
      content: [
        {
          innerTitle: "Three degrees of freedom (3DoF)",
          innertText: `
            <b>Definition</b>: With a VR system that allows for 3DoF, the users’ position is fixed and they cannot interact or move around in the environment. Users cannot interact with the environment and objects (zoom, rotate) or customize them.
            <br/><br/>
            <b>Pros</b>: It can be experienced from web/mobile or through cheap VR headsets.
            <br/><br/>
            <b>Cons</b>: It doesn’t bring any added value to the sales process on web and mobile, and it causes motion sickness.
            `
        },
        {
          innerTitle: "Six degrees of freedom (6DoF)",
          innertText: `
            <b>Definition</b>: With a VR system that allows for 6DoF, the users can move around freely within a limited space. This enables the users to fully interact with the environment and objects, rotate, zoom, change position, customize, have animations and see information on products.
            <br/><br/>
            <b>Pros</b>: It enables advanced interactivity, with potentially endless possibilities of movement and no motion sickness.
            <br/><br/>
            <b>Cons</b>: Longer production time and higher costs, optimal experience on high-end VR headsets.
            `
        }
      ]
    },
    {
      isDouble: true,
      title: "What is the difference between Photogrammetry and Optimized 3D Commerce objects?",
      content: [
        {
          innerTitle: "Photogrammetry",
          innertText: `
            <b>Definition</b>: Technology that allows you to automatically recreate a 3D object from its pictures achieving realistic shape and photographic resemblance.
            <br/><br/>
            <b>Pros</b>: Quick turnaround with no need for intervention by tech 3D artists.
            <br/><br/>
            <b>Cons</b>: No possibility to configure the object in its parts and no possibility to visually render the physical specs of the different materials. The content is not compliant with every online platform.
            `
        },
        {
          innerTitle: "Optimized 3D Commerce objects",
          innertText: `
            <b>Definition</b>: A certified common 3D standard by The Khronos Group aimed at recreating an object from CADs, photos or scanning in a standard file format (GLTF 2.0), enabling consistent quality, photorealistic textures, and simulation of physical-based materials that are compliant with principles of light reflection, refraction etc.
            <br/><br/>
            <b>Pros</b>: The compressed and optimized 3D objects are suitable for uploading in different contexts (web, AR, immersive VR) without affecting quality and performance of the experience. The content compliant for 3D commerce standard is certified for usage on every online immersive platform.
            <br/><br/>
            <b>Cons</b>: Finalization by tech 3D artists is required, following tight guidelines and international standards. This can be partially or totally conducted during the production/design process of the real object.
            `
        }
      ]
    },
    {
      isDouble: true,
      title: "What is the difference between a 360 environment and a real-time rendering environment?",
      content: [
        {
          innerTitle: "360 environment",
          innertText: `
            <b>Definition</b>: Environment realized through 360° photos or videos connected through interactive hotspots and viewed on web/mobile or through 3DoF VR headsets. The environment must physically exist.
            <br/><br/>
            <b>Pros</b>: Quickly realizable and photorealistic.
            <br/><br/>
            <b>Cons</b>: Limited interaction with objects, partial freedom of movement and frequent motion sickness. The experiential and emotional aspect of the experience is limited.
            `
        },
        {
          innerTitle: "Real-time rendering (RTR) environment",
          innertText: `
            <b>Definition</b>: Full 3D environment simulated through RTR Engines are interactive and can be experienced through web, mobile and 6DoF VR. The environment doesn’t need to physically exist.
            <br/><br/>
            <b>Pros</b>: Possibility to simulate environments in interactive and multimedia contexts, where it is possible to experience and interact with 3D objects, audio and video without motion sickness, and live any imaginable, emotional experiences.
            <br/><br/>
            <b>Cons</b>: 3D design of the environment and products is required. A semi-manual environment finalization is required. This can be partially or totally conducted during the production/design process of the real environment.
            `
        }
      ]
    },
    {
      isDouble: true,
      title: "What is the difference between a 360 product and a real-time rendering product?",
      content: [
        {
          innerTitle: "360 product",
          innertText: `
            <b>Definition</b>: Product realized through 360° photos or videos, viewed on web/mobile or experienced through 3DoF VR headsets. The product must physically exist.
            <br/><br/>
            <b>Pros</b>: Quickly realizable and photorealistic.
            <br/><br/>
            <b>Cons</b>: Limited interaction with objects, impossibility to configure them in their parts and time and cost-consuming photographic shoots in case collections envisage multiple variants.
            Frequent insurgence of motion sickness due to 3DoF fruition. The experiential and emotional aspect is limited.            
            `
        },
        {
          innerTitle: "Real-time rendering (RTR) product",
          innertText: `
            <b>Definition</b>: Full 3D product simulated through RTR Engines, interactive, customizable, experienced on web, mobile, 6DoF VR headsets or AR. The product doesn’t need to physically exist.
            <br/><br/>
            <b>Pros</b>: Possibility to simulate products within interactive and multimedia contexts, where it is possible to experience additional audio and video, creating emotional experiences without motion sickness.
            <br/><br/>
            <b>Cons</b>: 3D design of the product is required.<br/>
            A semi-manual object finalization procedure is required. This can be partially or totally conducted during the production/design process of the real object.            
            `
        }
      ]
    }
  ]

  const toggleAccordion = (index) => {
    
    setCurrentAcc(index === currentAcc ? -1 : index)
  }

  return (
    <React.Fragment>
      {
       
          <StyledAccordionWrapper>
            <div className="accordion--wrap">
              <h5 className="big--title">
              Reveal the answers to our most frequently asked tech questions
              </h5>
              {
                arrayAccordion.map((key, i) => {
                  return <AccordionSingle key={i} 
                          title={key.title}
                          isOpen={currentAcc === i}
                          index={i}
                          isDouble={key.isDouble}
                          changeCurrent={toggleAccordion}
                          content={key.content}
                          
                        />
                })
              }
            </div>
          </StyledAccordionWrapper>
          
      }
    </React.Fragment>
  );
};



export default AccordionWrapper;
